import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ClaimDashboardModel} from '../../api/ms-claims/contracts/claim-dashboard.model';
import {finalize} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {Permission} from '../../shared/utils/permission.enum';
import {UserService} from '../../shared/services/user.service';
import {ClaimsApi} from '../../api/ms-claims/claims.api';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardCardComponent implements OnInit {

    @Input() partnerCode: string;
    @Input() partnerName: string;
    @Output() claimReady = new EventEmitter<void>();

    show: boolean;
    hasError = false;
    eventSent = false;
    isReload = false;
    timer: any;
    claimsDashboard: ClaimDashboardModel;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private userService: UserService,
        private claimsService: ClaimsApi
    ) {}

    ngOnInit(): void {
        this.getClaims();
    }

    reloadClaims(): void {
        this.isReload = true;
        this.show = false;
        this.hasError = false;
        this.getClaims();
    }

    getClaims(): void {
        if (this.userService.hasPermissions([Permission.ADMIN_CLAIM_VIEW, Permission.PARTNER_CLAIM_VIEW])) {

            // If request takes too long just start with the next one already, only on initial load
            if (!this.isReload) {
                this.timer = setTimeout(() => {
                    // Handle racing condition against REST request
                    if (!this.eventSent) {
                        this.eventSent = true;
                        this.claimReady.next();
                    }
                }, 4000);
            }

            this.subscriptions.add(
                this.claimsService.getClaimsDashboard(this.partnerCode)
                    .pipe(finalize(() => {
                        // Handle racing condition against Timeout
                        if (!this.isReload && !this.eventSent) {
                            this.claimReady.next();
                            clearTimeout(this.timer);
                            this.eventSent = true;
                        }
                        this.show = true;
                    }))
                    .subscribe((dashboardResult) => {
                        this.claimsDashboard = dashboardResult;
                    }, () => {
                        this.hasError = true;
                    })
            );
        }
    }

}
